import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Convention, ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Graphic } from '../../packages/graphics/Graphic';
import { Shape } from '../../packages/shapes/Shape';
import { place, swallow } from '../commands/OrderCommands';
import { Physical } from './Physical';

export interface ContainerLike extends Physical {
    container: boolean;
}

export const ContainerLike = new Convention<ContainerLike>('ContainerxLike');

export class PhysicalMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start(): void {
        this.objects.createTrigger('ContainerLike.OnContainerChange')
            .for(ContainerLike)
            .onChangesTo('container').doForEach(this.ejectChildrenIfNotContainer);
    }

    private ejectChildrenIfNotContainer = (x: Shape | Graphic) => {
        if (x.container) {
            this.dispatch(swallow, [x.id]);
        }
        else {
            this.dispatch(place, [x.polarize(Physical).map(c => c.id)]);
        }
    };
}
